<template>
  <a
    :href="`${downloadUrl}/download_resource/${resource.resource_id}?access_token=${token}`"
    target="_blank"
  >
    <card :padding="4" dis-hover class="resources-item">
      <div class="resources-item__container">
        <div class="resources-item__icon">
          <icon size="16" type="md-document" class="ms-help" />
        </div>
        <div class="resources-item__info">
          <div class="resources-item__name ms-small-head">
            {{ resource.resources_file_name }}
          </div>
          <!-- <div
            class="resources-item__type ms-link"
            v-if="resource.procedure_type_name"
          >
            {{ resource.procedure_type_name }}
          </div>
          <div
            class="resources-item__type ms-link"
            v-if="!resource.procedure_type_name"
          >
            {{ resource.file_type_name }}
          </div> -->
        </div>
        <div class="resources-item__right">
          <tag class="resources-item__date ms-help">
            {{ parseDateTime(resource.resources_created_at) }}
          </tag>
        </div>
      </div>
    </card>
  </a>
</template>

<script>
import { mainUrl } from '@/config/urls'
import { parseDateTime } from '@/utils'

const objectTypes = {
  contracts: 'Материалы договора',
  acts: 'Акты',
  payments: 'Платежи',
  law_cases: 'Судебные дела',
  procedures: 'Запросы материалов'
}

export default {
  props: ['resource'],
  data () {
    return {
      token: this.$store.state.auth.token,
      downloadUrl: `${mainUrl}/api`,
      objectTypes
    }
  },
  methods: {
    parseDateTime
  }
}
</script>

<style lang="less">
.resources-item {
  margin-bottom: 8px;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  &__name {
    word-break: break-word;
    font-size: 12px;
  }

  &__container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__icon {
    margin-right: 12px;
    border: 2px solid #9ea7b4;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
  }

  &__info {
    flex: 1;
    margin-right: 16px;
  }

  &__right {
    margin-left: auto;
  }
}
</style>
